<template>
	<form @submit.prevent="send" :action="action" :method="method || 'post'">
		<slot :object="object" :form="form" :errors="errors" :loading="loading"></slot>
	</form>
</template>

<script>
	export default {
		props: ['action', 'method', 'formData', 'objectData', 'unsaveable'],
		data() {
			return {
				loadCount: 0,
				object: {},
				form: {},
				errors: {}
			};
		},
		computed: {
			loading() {
				return this.loadCount > 0;
			}
		},
		watch: {
			loadCount() {
				this.$emit('loading', this.loading);
			},
			formData: {
				async handler() {
					if(typeof(this.formData) === 'string') {
						this.loadCount++;
						try {
							this.form = await this.$get(this.formData);
						} catch(e) {
							this.form = {};
						}
						this.loadCount--;
						return;
					}
					this.form = (this.formData)?this.formData:{};
				},
				immediate: true
			},
			objectData: {
				async handler() {
					if(typeof(this.objectData) === 'string') {
						this.loadCount++;
						try {
							this.object = await this.$get(this.objectData);
						} catch(e) {
							this.object = {};
						}
						this.loadCount--;
						return;
					}
					this.object = (this.objectData)?this.objectData:{};
				},
				immediate: true
			}
		},
		methods: {
			async save(event) {
				if(this.unsaveable) {
					return;
				}
				if (event.keyCode === 83 && event.ctrlKey) {
			        event.preventDefault();
			    	await this.send();
			    }  
			},
			async send() {
				if(this.loading) {
					return;
				}
				this.loadCount++;
				this.errors = {};
				try {
					this.object = await this['$' + (this.method || 'post')](this.action, this.object);
					this.$emit('submit', this.object);
				} catch(e) {
					if(e.data){
						this.errors = e.data;
					}
				}
				this.loadCount--;
			}
		},
		mounted() {
			document.addEventListener('keydown', this.save);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.save);
		}
	}
</script>